/* DentalPets PDP V2 — minimal behaviour (no dependencies).
   1. Scroll-to-Kaching for [data-dp-scroll-to-kaching] links (mid CTA, final CTA, sticky CTA).
   2. Sticky CTA visibility (shown once the purchase form has scrolled out of view).
   3. UGC video strip: click to play/pause, one at a time, no preloading.
   4. Reviews masonry (measured row spans). The Before/After slider uses the theme's own m-image-comparison component. */
(function () {
  'use strict';

  function purchaseTarget() {
    return (
      document.querySelector('kaching-bundles-block') ||
      document.querySelector('.kaching-bundles') ||
      document.querySelector('.m-product-form--main') ||
      document.getElementById('dp-purchase')
    );
  }

  function headerOffset() {
    var header = document.querySelector('.m-header.m\\:sticky-element, .m-header[data-sticky="on_scroll_up"], .m-header[data-sticky="always"]');
    return header && header.getBoundingClientRect().height < 200 && getComputedStyle(header).position === 'sticky' ? header.getBoundingClientRect().height : 0;
  }

  function scrollToPurchase(event) {
    var target = purchaseTarget();
    if (!target) return; // no JS target: let the anchor href (#dp-purchase) work natively
    event.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-dp-scroll-to-kaching]');
    if (link) scrollToPurchase(event);
  });

  /* Sticky CTA */
  function initSticky() {
    var bar = document.querySelector('[data-dp-sticky-cta]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var form = document.querySelector('.m-product-form--main') || document.getElementById('dp-purchase');
    var finalCta = document.querySelector('[data-dp-final-cta]');
    if (!form) return;
    var pastForm = false;
    var atFinal = false;
    function update() { bar.classList.toggle('is-visible', pastForm && !atFinal); }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastForm = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }, { threshold: 0 }).observe(form);
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        atFinal = entries[0].isIntersecting;
        update();
      }, { threshold: 0.2 }).observe(finalCta);
    }
  }

  /* UGC videos */
  function initUgc() {
    var cards = document.querySelectorAll('[data-dp-ugc-card]');
    if (!cards.length) return;
    function pauseOthers(current) {
      cards.forEach(function (card) {
        if (card === current) return;
        var v = card.querySelector('video');
        if (v && !v.paused) v.pause();
        card.classList.remove('is-playing');
      });
    }
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      card.addEventListener('click', function () {
        if (video.paused) {
          pauseOthers(card);
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    });
  }

  /* Keep the template-scoped ATC label if the theme JS re-renders the button text */
  function initAtcLabel() {
    var btn = document.querySelector('.m-product-form--main .m-add-to-cart[data-atc-text]');
    if (btn && btn.dataset.atcText && window.MinimogStrings) window.MinimogStrings.addToCart = btn.dataset.atcText;
  }

  /* Reviews masonry: measured row spans on the existing review block (data untouched, layout only) */
  function initMasonry() {
    var grid = document.querySelector('.dentalpets-v2 [class^="ai-reviews-masonry-"]');
    if (!grid) return;
    var timer = null;
    function layout() {
      var cs = getComputedStyle(grid);
      var row = parseFloat(cs.gridAutoRows) || 8;
      var gap = parseFloat(cs.rowGap) || 0;
      grid.querySelectorAll('[class^="ai-review-card-"]').forEach(function (card) {
        card.style.gridRowEnd = 'auto';
        if (getComputedStyle(card).display === 'none') return;
        var h = card.getBoundingClientRect().height;
        card.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil((h + gap) / (row + gap)));
      });
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(layout, 60); }
    layout();
    grid.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', schedule, { once: true }); });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(grid);
    new MutationObserver(schedule).observe(grid, { attributes: true, attributeFilter: ['class'], subtree: true });
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    setTimeout(schedule, 800);
  }

  function init() { initAtcLabel(); initSticky(); initUgc(); initMasonry(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function () { initUgc(); });
})();
